import axios from "axios";
import { API_BASE_URL } from "../../config/api";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";

const getDeviceAndBrowserInfo = () => {
  const userAgent = navigator.userAgent;
  let device_type = "Unknown";
  let device_name = "Unknown";
  console.log(userAgent);
  if (userAgent.includes("Windows")) {
    device_type = "W";
  } else if (userAgent.includes("Macintosh")) {
    device_type = "W";
  } else if (userAgent.includes("Linux")) {
    device_type = "W";
  }
  if (userAgent.includes("Chrome")) {
    device_name = "Chrome";
  } else if (userAgent.includes("Safari")) {
    device_name = "Safari";
  } else if (userAgent.includes("Firefox")) {
    device_name = "Firefox";
  } else if (userAgent.includes("Edge")) {
    device_name = "Edge";
  } else if (userAgent.includes("Opera")) {
    device_name = "Opera";
  }
  if (/Android/i.test(userAgent)) {
    device_type = "A";
  } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
    device_type = "I";
  } else {
    device_type = "W";
  }
  return { device_type, device_name };
};

function generateRandomToken() {
  const token = localStorage.getItem("FCM-WEB");
  console.log(token);
  return token;
}

const path = window.location.pathname;

// const API_BASE_URL = process.env.REACT_APP_BASE_URL;
const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
const fcmToken = localStorage.getItem("FCM");
const deviceName = localStorage.getItem("DeviceName");
const deviceType = localStorage.getItem("DeviceType");
const deviceToken = localStorage.getItem("DeviceToken");

//console.log(fcmToken, deviceName, deviceType, deviceToken, "fcmcmcmmc");
let fcmHeaderValue, deviceNameValue, deviceTypeValue, deviceTokenValue;

if (fcmToken !== null && fcmToken !== undefined) {
  fcmHeaderValue = fcmToken;
} else {
  fcmHeaderValue = generateRandomToken();
  if (fcmHeaderValue == "" || fcmHeaderValue == null) {
    localStorage.getItem("FCM-WEB");
  }
  //console.log(fcmHeaderValue, "fcfcfcfcs");
  // fcmHeaderValue = localStorage.get("FCM-WEB") || "" // Default value if FCM token is not present
}
if (deviceName != null && deviceName != undefined) {
  console.log("present device name");
  deviceNameValue = deviceName;
} else {
  console.log("notpresent name");
  deviceNameValue = getDeviceAndBrowserInfo().device_name; // Default value if DeviceName is not present
}
if (deviceType != null && deviceType != undefined) {
  console.log("present device type");
  deviceTypeValue = deviceType;
} else {
  console.log(" present device type not");
  deviceTypeValue = getDeviceAndBrowserInfo().device_type; // Default value if DeviceType is not present
}
if (deviceToken !== null && deviceToken !== undefined) {
  console.log("present device Token");
  deviceTokenValue = deviceToken;
} else {
  const storedDeviceId = localStorage.getItem("deviceId");
  if (!storedDeviceId) {
    const generatedDeviceId = uuidv4();
    localStorage.setItem("deviceId", generatedDeviceId);
    deviceTokenValue = generatedDeviceId;
  } else {
    deviceTokenValue = storedDeviceId;
  }
}

function generateRandomToken1(length) {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let token = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    token += characters.charAt(randomIndex);
  }
  return token;
}

const token = generateRandomToken1(20);

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    Authorization:
      "Bearer " + localStorage.getItem("accessToken") &&
      JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token,
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue
      ? deviceNameValue
      : localStorage.getItem("DeviceName"),
    "Device-Token": deviceTokenValue
      ? deviceTokenValue
      : localStorage.getItem("DeviceToken"),

    "App-Version": "1.0.0",
    Timezone: timeZone,
  },
});

axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Any status codes that fall outside the range of 2xx cause this function to trigger
    if (error.response && error.response.status === 401) {
      // Handle the 401 error
      console.log(error.response.data.message, "responsesesese");
      toast.error(error.response.data.message);
      console.error("Unauthorized! Logging out...");
      // Here, implement your logic for clearing local storage or cookies that hold authentication info
      localStorage.clear(); // This removes everything in localStorage; adjust if necessary.
      // Redirect the user to the login page
      window.location.href = "/login"; // Adjust the path according to your routing
    }
    return Promise.reject(error);
  }
);
// Retrieve fcmToken from localStorage or use default value '12345'

export const signUpApi = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}signup`, body);
  return response;
};

export const getCountries = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}getCountries`, body);
  return response;
};

export const login = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}login`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};
export const sendotp = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}send-otp`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const verifyotp = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}verify-otp`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const SocialLogin = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}social-login`,
    body,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response;
};

export const forgotPassword = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}forgot-password`,
    body,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response;
};

export const getProfile = async (id, game_id = null) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-profile`,
      {
        user_id: id,
        game_id: game_id
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error get in profile:", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getProfileImage = async (id, game_id = null) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-profile-image`,
      {
        user_id: id,
        game_id: game_id
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error get in profile:", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};

export const updateProfile = async (body) => {
  console.log(body, "bo");
  // Create a FormData object
  const formData = new FormData();

  const imagePath = body?.image;
  console.log(imagePath, "imagepath");
  if (imagePath && imagePath.length > 0 && imagePath !== "null") {
    formData.append("image", imagePath);
  }
  formData.append("full_name", body.full_name);
  formData.append("email", body.email);
  formData.append("country_code", body.countryCode);
  formData.append("phone", body.phone);
  formData.append("biography", body.biography);
  formData.append("trading_type_id", body.trading_type_id);
  formData.append("subscription_plan_amount", body.subscription_plan_amount);
  formData.append("is_chat_paid", body.chat_type);
  formData.append("title", body.title);
  formData.append("link", body.link);
  formData.append("user_name", body.user_name);
  formData.append("date_of_birth", body.date_of_birth);
  formData.append("country_of_origin", body.country_of_origin);

  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}update-profile`,
      formData,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error updating profile:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const deleteAdminsistrator = async (body) => {
  const response = await axiosInstance.post(
    `${API_BASE_URL}deleteAdministrator`,
    body,
    {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    }
  );
  return response;
};

export const changePassword = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}change-password`,
      body,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error changing password:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const logout = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}logout`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getpost = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}get-post`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const createPost = async (body) => {
  console.log('body is',body);
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-update-post`,
      body,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getNotifications = async (page) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-notification`,
      { page: page, limit: 10 },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting notifications:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getSettings = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}app-settings`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting settings:", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getS3 = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}s3-token`, // URL is the first argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting s3 token:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const s3Upload = async (newImages) => {
  console.log(newImages, "newnew");
  console.log(JSON.stringify(newImages), "newnew");

  const formData = new FormData();
  newImages.forEach((img, index) => {
    console.log(JSON.stringify(img, "img"));
    console.log(`Image ${index + 1}:`, img.blob);
    console.log(`Image ${index + 1}:`, JSON.stringify(img.blob));

    // Append each image blob to formData with the key 'files[]'
    formData.append("files[]", img.blob);
  });
  const headers = {
    Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue,
    "Device-Token": deviceTokenValue,
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token, // Use the default value if fcmToken is null or undefined
    "App-Version": "1.0.0",
    Timezone: timeZone,
  };
  console.log(formData);
  try {
    const response = await axios.post(`${API_BASE_URL}s3-upload`, formData, {
      headers: {
        ...headers,
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data", // Let FormData handle Content-Type
      },
    });

    return response;
  } catch (error) {
    console.error("Error uploading to s3:", error);
    throw error; // Handle this according to your application's needs
  }
};

// export const getAllPost = async (search_term, params) => {
//  console.log(search_term,'search_term');
//  console.log(params,'params');
//   const body = {
//     page:params,
//     limit: 10,
//     search_term: search_term ? search_term : "",
//   };
//  console.log(body,'----------sdfsfdsfgsfg---------');
//     if (params.game_id) {
//     body.game_id = params.game_id;
//   }

//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}get-all-post`,
//       body, // Pass the 'body' object as the second argument
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//           "Content-Type": "multipart/form-data",
//           "Device-Type": deviceTypeValue,
//           "Device-Name": deviceNameValue,
//           "Device-Token": deviceTokenValue,
//           "Fcm-Token": localStorage.getItem("FCM-WEB")
//             ? localStorage.getItem("FCM-WEB")
//             : localStorage.getItem("FCM")
//             ? localStorage.getItem("FCM")
//             : token, // Use the default value if fcmToken is null or undefined
//           "App-Version": "1.0.0",
//           Timezone: timeZone,
//         },
//       }
//     );

//     return response;
//   } catch (error) {
//     console.error("Error getting all posts:", error);
//     throw error;
//   }
// };


export const getAllPost = async (search_term, page) => {
const body = {
  page: search_term ? page : page.page, // Default is page.page; if search_term is set, use page
  limit: 10,
  search_term: search_term || "", // Default is an empty string
};

  console.log(body,'------------------------');
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-all-post`,
      body, // Pass the 'body' object as the second argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};


export const getMyPost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-all-post`,
      id,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};

export const getPaidPost = async (dataObj) => {
  try {
    const body = {
      user_id: dataObj?.user_id,
      post_status: dataObj?.post_status,
      page: dataObj.page,
      limit: 10,
    };
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-all-post`,
      body, // Pass the 'body' object as the second argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};

export const likeDislike = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}like-dislike-post`, // URL is the first argument
      { post_id: id }, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      } // Configuration object is the third argument
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error like dislike :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const addComment = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}post-comment`, // URL is the first argument
      body, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      } // Configuration object is the third argument
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in add comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getComment = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-comment`, // URL is the first argument
      { post_id: id }, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in add comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const deletePost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-post`, // URL is the first argument
      { post_id: id }, // Empty data object if no payload is needed
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete post :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getLeaderBoard = async (game_id = null) => {
  const body = {
    page: 1,
    limit: 100,
    game_id: game_id
  };
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}leaderboard`,
      body, // Pass the 'body' object as the second argument
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error get Leaderboard :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const getUserFollowers = async (userId) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-follower-list`,
      { list_type: 1,
       receiver_id: userId, },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};


export const getUserPerformance = async (userId,startDate,endDate) => {
  console.log(startDate);
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-user-performance`,
      {
       userId: userId, start_date:startDate,end_date:endDate},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};


export const deleteComment = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-post-comment`,
      { id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const followUnfollow = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}friend-request`,
      body,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const repostPost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}repost`,
      {
        repost_id: id,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const undoRepostPost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}undo-post`,
      {
        post_id: id,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error delete in comment :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const tradingType = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-trading-type`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};
export const chatList = async (type) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-chat-list`,
      {
        chat_type: type,
        limit: 100,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const chatDetails = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-chat-detail`,
      data?.receiver_id
        ? {
            receiver_id: data?.receiver_id,
            page: 1,
            limit: 200,
            ...(data?.game_id && { game_id: data.game_id }),
          }
        : data?.chat_group_id
        ? { chat_group_id: data?.chat_group_id, page: 1, limit: 200, ...(data?.game_id && { game_id: data.game_id }),  }
        : "",
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting chat details :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
// export const joinChat = async (gid, id) => {
//
//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}join-chat`, { chat_group_id: gid, type: 1 }
//     );

//     return response;
//   } catch (error) {
//     // Handle error
//     console.error('Error getting in joining chat :', error);
//     throw error; // You might want to handle this differently based on your application's needs
//   }
// };
// export const sendMessage = async (mess, id) => {
//
//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}send-message`, { message: mess, receiver_id: id, type: 1 }
//     );

//     return response;
//   } catch (error) {
//     // Handle error
//     console.error('Error getting in joining chat :', error);
//     throw error; // You might want to handle this differently based on your application's needs
//   }
// };
export const deleteChat = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-chat`,
      { chat_group_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in delete chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteMessage = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-message`,
      {
        body,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const sendNoti = async (body) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}send-notification`,
      { body },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getSavedPost = async (e) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-saved-post`,
      { page: e },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const savePost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}save-post`,
      {
        post_id: id,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteSavePost = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-saved-post`,
      { saved_post_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const createPaymentApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}payment-method`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getPaymentCardsApi = async () => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-payment-method`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};


export const createPaymentIntent = async () =>{
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-payment-intent`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in payment intent :", error);
  }
}


export const checkTransactionStatus = async (paymentId) =>{
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}check-transaction-status`,
      {payment_id:paymentId},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in payment intent :", error);
  }
}

export const resetPortfolio = async (paymentId) =>{
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}reset-portfolio`,
      {payment_id:paymentId},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in payment intent :", error);
  }
}

export const deleteCardApi = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-payment-method
      `,
      { payment_method_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const makePaymentApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}payment
      `,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const setPrimaryMethod = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}set-primary-method
      `,
      { payment_method_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getSubscriptionMethod = async () => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-subscription
      `,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const cancelSubscription = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}cancle-subscription
      `,
      { subscription_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting in joining chat :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const searchStocksApi = async (data) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}${
        window.location.pathname == "/auth/trending-stocks"
          ? "trending-stocks"
          : "stocks/search"
      }${data ? "?search=" + data : ""}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const createConnectAccountApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-connect-account`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const voteMarket = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-vote`,
      {
        vote_type: data,
      },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const marketSentiment = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-market-sentiment`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const searchStock = async (data) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}stock-details?ticker=${data}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getOrder = async (data, id, game_id = null) => {
  try {
    const requestBody = {
      type: data,
    };

    if (id) {
      requestBody.user_id = id; // Include user_id only if id is available
    }

    if (game_id) {
      requestBody.game_id = game_id;
    }

    const response = await axiosInstance.post(
      `${API_BASE_URL}get-order`,
      requestBody,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in getOrder:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const createOrder = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}create-update-order`,

      data,

      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const clearNotification = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}clear-badge`,
      { type: data },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );
    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const getChartStockDetails = async (data) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}chart-stock-details?ticker=${data}`,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const s3SingleUpload = async (newImages) => {
  const formData = new FormData();
  formData.append("files[]", newImages);
  const headers = {
    Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue,
    "Device-Token": deviceTokenValue,
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token,
    "App-Version": "1.0.0",
    Timezone: timeZone,
  };

  try {
    const response = await axios.post(`${API_BASE_URL}s3-upload`, formData, {
      headers: {
        ...headers,
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data", // Let FormData handle Content-Type
      },
    });

    return response;
  } catch (error) {
    console.error("Error uploading to s3:", error);
    throw error; // Handle this according to your application's needs
  }
};

export const saveChart = async (data, ticker) => {
  try {
    const formData = new FormData();
    formData.append("image_json", JSON.stringify(data));
    formData.append("ticker", ticker);
    const response = await axiosInstance.post(
      `${API_BASE_URL}save-chart`,
      formData,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    // Handle error
    console.error("Error in voting :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getSavedCharts = async () => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-saved-chart`,
      {},
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const cancelOrderApi = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}order-cancel`,
      { order_id: id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const addChartNotification = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}add-notification`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteAccount = async () => {
  try {
    const response = await axiosInstance.get(`${API_BASE_URL}delete-account`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const reportPostApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}report-post`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const blockUnblockUserApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}block-unblock-user`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const checkUsername = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}verify-user-name`,
      data,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getFollowersListApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-friend-list`,
      { list_type: 1 },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    // throw error; // You might want to handle this differently based on your application's needs
  }
};

export const shareSavedChartApi = async (data) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}share-saved-chart`,
      { chart_id: data?.chart_id, users: data?.users },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const sentimentReportApi = async (data) => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}sentiment-report
      `,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const shareCartAsPostApi = async (chart_id, inputValue,game_id = null) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}share-as-post`,
      { chart_id: chart_id, description: inputValue,...(game_id && { game_id: game_id }), },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};
export const deleteSavedChart = async (chart_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}delete-saved-chart`,
      { id: chart_id },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const legalDisclaimerApi = async (disclaimer) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}legal-disclaimer`,
      { disclaimer: "1" },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting trading type :", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

//Game Contest Api


export const storeTempImage = async (filePath) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}upload-temp`,
      { filePath },
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "application/json",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token,
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response.data.url; // Return the public URL
  } catch (error) {
    console.error("Error storing temporary image:", error);
    throw error;
  }
};





export const gameImageUpload = async (newImages) => {
  console.log(newImages, "newnew");
  console.log(JSON.stringify(newImages), "newnew");

  const formData = new FormData();
  newImages.forEach((img, index) => {
    console.log(JSON.stringify(img, "img"));
    console.log(`Image ${index + 1}:`, img.blob);
    console.log(`Image ${index + 1}:`, JSON.stringify(img.blob));

    // Append each image blob to formData with the key 'files[]'
    formData.append("files[]", img.blob);
  });
  const headers = {
    Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
    "Content-Type": "application/json",
    "Device-Type": deviceTypeValue,
    "Device-Name": deviceNameValue,
    "Device-Token": deviceTokenValue,
    "Fcm-Token": localStorage.getItem("FCM-WEB")
      ? localStorage.getItem("FCM-WEB")
      : localStorage.getItem("FCM")
      ? localStorage.getItem("FCM")
      : token, // Use the default value if fcmToken is null or undefined
    "App-Version": "1.0.0",
    Timezone: timeZone,
  };
  try {
    const response = await axios.post(`${API_BASE_URL}uploadForGame`, formData, {
      headers: {
        ...headers,
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data", // Let FormData handle Content-Type
      },
    });

    return response;
  } catch (error) {
    console.error("Error uploading to s3:", error);
    throw error; // Handle this according to your application's needs
  }
};


export const getAllGame = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-all-game`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all posts:", error);
    throw error;
  }
};


export const getMyGame = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-my-game`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};

export const getCashLeague = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-cash-game`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};

export const getMemberGame = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-member-game`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};

export const getAllGames = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-all-my-games`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting my posts:", error);
    throw error;
  }
};


export const getVanityUrl = async () => {
  try {
    const response = await axiosInstance.get(
      `${API_BASE_URL}get-vanity-url`,
      {
        headers: {
          Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting vanity url:", error);
    throw error;
  }
};




export const CreateGames = async (body) => {
  console.log(body,'body');
  const response = await axiosInstance.post(`${API_BASE_URL}create-game`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};

export const editGame = async (body) => {
  // console.log(body, 'Request Body----------------');
  console.log(JSON.stringify(body, null, 2), 'Request Body with all values');

  const response = await axiosInstance.post(`${API_BASE_URL}edit-game`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  console.log(response,'response is');
  return response;
};


export const deleteGameImage = async (body) => {
  console.log(body, 'delete Game Body');
  const response = await axiosInstance.post(`${API_BASE_URL}delete-game-image`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  console.log(response,'response is');
  return response;
};


export const getgame = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}get-game`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const updatePhoneNumber = async (phone,country_of_origin) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}update-phone-number`,
      { phone ,country_of_origin },
      {
        headers: {
          Authorization: `Bearer ${JSON.parse(localStorage.getItem("accessToken"))}`,
          "Content-Type": "application/json",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token":
            localStorage.getItem("FCM-WEB") ||
            localStorage.getItem("FCM") ||
            token, // Use default if FCM token is null
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    if (response.status === 200) {
      return response.data; // ✅ Return the actual data
    } else {
      throw new Error(response.data.message || "Failed to update phone number.");
    }
  } catch (error) {
    console.error("Error updating phone number:", error.response?.data || error);
    throw error;
  }
};


export const joingame = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}join-game`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const getGameFromSlug = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}get-game-from-slug`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};



//Invitations
export const sendInvitation = async (body) => {
  const response = await axiosInstance.post(`${API_BASE_URL}send-invitation`, body, {
    headers: {
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
      "Content-Type": "multipart/form-data",
      "Device-Type": deviceTypeValue,
      "Device-Name": deviceNameValue,
      "Device-Token": deviceTokenValue,
      "Fcm-Token": localStorage.getItem("FCM-WEB")
        ? localStorage.getItem("FCM-WEB")
        : localStorage.getItem("FCM")
        ? localStorage.getItem("FCM")
        : token, // Use the default value if fcmToken is null or undefined
      "App-Version": "1.0.0",
      Timezone: timeZone,
    },
  });
  return response;
};


export const getGameFromToken = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}game-token`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const getInvitationFromToken = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}verfiy-token`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const updateInvitationStatus = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}update-invitation-status`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const declineInvitation = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}decline-invitation`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};



export const acceptInvitation = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}accept-invitation`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const passwordCheck = async (body) => {
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}validate-password`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};



//Sign In Apple Integration

export const sendAppleWebResponse = async (body) => {
  console.log(body,'my body is');
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}send-apple-response`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};

export const checkCashUser = async (body) => {
  console.log(body,'body in api call is');
  try {
    const response = await axiosInstance.post(`${API_BASE_URL}check-cash-user`, body, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Content-Type": "multipart/form-data",
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : token, // Use the default value if fcmToken is null or undefined
        "App-Version": "1.0.0",
        Timezone: timeZone,
      },
    });

    return response;
  } catch (error) {
    // Handle error
    console.error("Error logout:", error);
    throw error; // You might want to handle this differently based on your application's needs
  }
};


export const getTradingVideos = async (category_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-videos`,
      category_id,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};

export const incrementView = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-view`,
      id,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};


export const getTradingSingleVideos = async (category_id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-single-videos`,
      category_id
    );
    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};

export const incrementSingleView = async (id) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-single-view`,
      id,
    );
    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};

export const getSingleVideo = async (videoId) => {
  try {
    const response = await axiosInstance.post(
      `${API_BASE_URL}get-trading-video`,
      videoId,
      {
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
          "Content-Type": "multipart/form-data",
          "Device-Type": deviceTypeValue,
          "Device-Name": deviceNameValue,
          "Device-Token": deviceTokenValue,
          "Fcm-Token": localStorage.getItem("FCM-WEB")
            ? localStorage.getItem("FCM-WEB")
            : localStorage.getItem("FCM")
            ? localStorage.getItem("FCM")
            : token, // Use the default value if fcmToken is null or undefined
          "App-Version": "1.0.0",
          Timezone: timeZone,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error getting all trading videos:", error);
    throw error;
  }
};


export const trackPageView = async () => {
  try {
    const response = await axiosInstance.get(`/track-pageview`, {
      headers: {
        Authorization: "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : null,
        "App-Version": "1.0.0",
        Timezone: timeZone,
        "Source-Page": window.location.href, // ✅ Full current URL
      },
    });

    return response;
  } catch (error) {
    console.error("Error in PageView tracking:", error);
  }
};


export const trackViewContent = async () => {
  try {
    const response = await axiosInstance.get(`/track-viewcontent`, {
      headers: {
        Authorization:
          "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
        "Device-Type": deviceTypeValue,
        "Device-Name": deviceNameValue,
        "Device-Token": deviceTokenValue,
        "Fcm-Token": localStorage.getItem("FCM-WEB")
          ? localStorage.getItem("FCM-WEB")
          : localStorage.getItem("FCM")
          ? localStorage.getItem("FCM")
          : null,
        "App-Version": "1.0.0",
        Timezone: timeZone,
        "Source-Page": window.location.href, // now the full URL
      },
    });

    return response;
  } catch (error) {
    console.error("Error in ViewContent tracking:", error);
  }
};





// export const shareVideo = async (data) => {
//   try {
//     const response = await axiosInstance.post(
//       `${API_BASE_URL}share-video`,
//       data,
//       {
//         headers: {
//           Authorization:
//             "Bearer " + JSON.parse(localStorage.getItem("accessToken")),
//           "Content-Type": "multipart/form-data",
//           "Device-Type": deviceTypeValue,
//           "Device-Name": deviceNameValue,
//           "Device-Token": deviceTokenValue,
//           "Fcm-Token": localStorage.getItem("FCM-WEB")
//             ? localStorage.getItem("FCM-WEB")
//             : localStorage.getItem("FCM")
//             ? localStorage.getItem("FCM")
//             : token, // Use the default value if fcmToken is null or undefined
//           "App-Version": "1.0.0",
//           Timezone: timeZone,
//         },
//       }
//     );

//     return response;
//   } catch (error) {
//     console.error("Error getting all trading videos:", error);
//     throw error;
//   }
// };